import React, { Fragment, useCallback, useEffect, useState, useRef, useMemo } from 'react';
import { formatQuizAnswer } from '../../../utils/formatQuizAnswer';
import { Col, Card, CardHeader, CardBody, Form, Label, Container, Row } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { useReactToPrint } from 'react-to-print';
import { Btn } from '../../../AbstractElements';
import ConfirmationModal from '../../UiKits/ConfirmationModal';
import { ToastContainer, toast } from 'react-toastify';
import {
  useGetOrdersQuery,
  useOrderDetailsMutation,
  useAddStatusMutation,
} from '../../../features/ordersApiSlice';
import { downloadCsv } from '../../../utils';

const formatOrderItemsInline = (orderItems = []) => {
  if (!Array.isArray(orderItems) || orderItems.length === 0) return '-';
  return orderItems
    .map((item) => item?.product_name || item?.product_type || '-')
    .filter(Boolean)
    .join(', ');
};

const OrderItemsExpanded = ({ data }) => {
  const items = Array.isArray(data?.order_items) ? data.order_items : [];
  if (!items.length) return null;

  return (
    <div className="px-4 py-3 bg-light border-top">
      <div className="mb-3">
        <div className="fw-semibold text-dark">Order items</div>
        <div className="text-muted small">Detailed line items for order #{data?.id || '-'}</div>
      </div>
      <div className="table-responsive">
        <table className="table table-sm table-bordered align-middle mb-0" style={{ backgroundColor: "#ffffff", color: "#212529" }}>
          <thead style={{ backgroundColor: "#f8f9fa", color: "#212529" }}>
            <tr>
              <th style={{ color: "#212529", fontWeight: 600 }}>Order ID</th>
              <th style={{ color: "#212529", fontWeight: 600 }}>Item ID</th>
              <th style={{ color: "#212529", fontWeight: 600 }}>Product</th>
              <th style={{ color: "#212529", fontWeight: 600 }}>Product Type</th>
              <th style={{ color: "#212529", fontWeight: 600 }}>Line</th>
              <th style={{ color: "#212529", fontWeight: 600 }}>Price</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id || `${item.order_id}-${item.line_item}`} style={{ color: "#212529" }}>
                <td>{item.order_id || data?.id || '-'}</td>
                <td>{item.id || '-'}</td>
                <td>{item.product_name || '-'}</td>
                <td>{item.product_type || '-'}</td>
                <td>{item.line_item || '-'}</td>
                <td>{item.price || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const Orders = () => {
  const [data, setData] = useState([]);
  const [allOrders, setAllOrders] = useState([]);
  const [ingredients, setIngredients] = useState([]);
  const [statuses, setStatuses] = useState();

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');

  const [selectedRow, setSelectedRow] = useState();
  const [toggleSelect, setToggleSelect] = useState(false);

  const [getOrderDetails] = useOrderDetailsMutation();
  const [addStatus] = useAddStatusMutation();

  const [order, setOrder] = useState({
    orderNo: '',
    date: '',
    first_name: '',
    last_name: '',
    totalPrice: '',
    status: '',
    duration: '',
    transactionId: '',
    paymentMethod: '',
    paymentStatus: '',
    amount: '',
    customer_quiz_id: 1,
  });

  const [shipAddress, setShipAddress] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    country: '',
    address: '',
    appartment: '',
    state: '',
    zipCode: '',
    phoneNo: '',
    email: '',
  });

  const [status, setStatus] = useState('');
  const [details, setDetails] = useState('');
  const [questionsAnswers, setQuestionAnswers] = useState();
  const [personalInfo, setPersonalInfo] = useState();
  console.log('details => ', details);

  const [modalOpen, setModalOpen] = useState(false);

  const [showError, setShowError] = useState({ status: '', details: '' });

  const shippingAddressRef = useRef();

  const {
    data: fetchOrders,
    isLoading,
    isSuccess,
    isError,
    error,
    refetch,
  } = useGetOrdersQuery(
    {
      page: currentPage,
      limit: pageSize,
      search: debouncedSearchTerm,
      status: statusFilter,
    },
    { skip: false }
  );

  useEffect(() => {
    refetch();
  }, [refetch, currentPage, pageSize, debouncedSearchTerm, statusFilter]);

  useEffect(() => {
    const fn = () => {
      if (isSuccess && fetchOrders?.data) {
        setData(fetchOrders.data?.data || []);
        setAllOrders(fetchOrders.data?.data || []);
        setTotalRows(fetchOrders.data?.pagination?.total || 0);
      }
    };
    fn();
  }, [fetchOrders]);

  const handleRowSelected = useCallback((state) => {
    // setSelectedRow(state.selectedRows);
    // //console.log(selectedRow)
    //
    // if(state.selectedCount === 0) {
    //     reset();
    // }
  }, []);

  const handleAction = async (row) => {
    console.log(row);

    try {
      setSelectedRow(row);
      const res = await getOrderDetails({ order_id: row.id }).unwrap();

      console.log('ORDER DETAILS: ', res);
      setOrder(res.data[0]);
      setShipAddress(res.shippingAddress[0]);
      setIngredients(res.ingredients);
      setStatuses(res.status);
      setQuestionAnswers(res.questionsAnswers);
      setPersonalInfo(res.personalInfo?.[0]);

      //console.log(res.ingredients)
    } catch (e) {
      console.log(e);
    }
  };

  const toggleModal = () => {
    showErrorMessage('status', '');
    showErrorMessage('details', '');

    if (status === '') {
      showErrorMessage('status', 'Please select status.');
    } else {
      if (selectedRow) {
        setModalOpen(!modalOpen);
      }
    }
  };

  const showErrorMessage = (object, message) => {
    setShowError((prevValues) => ({
      ...prevValues,
      [object]: message,
    }));
  };

  const handleConfirmAction = () => {
    handleUpdateStatus();
  };

  const handleUpdateStatus = async () => {
    console.log(status, details);
    console.log(selectedRow.id);

    try {
      const res = await addStatus({
        order_id: selectedRow.id,
        status: status,
        details: details,
      }).unwrap();

      setStatuses(res.status);

      console.log(res);
      toast.success('Status updated successfully!');

      // setOrder(res.data[0])
      // setShipAddress(res.shippingAddress[0])
      // setIngredients(res.ingredients)
    } catch (e) {
      toast.error(e?.message || 'Something went wrong!');
      console.log(e);
    }
  };

  const printShipAddress = useReactToPrint({
    content: () => shippingAddressRef.current,
  });

  const tableColumns = [
    {
      name: 'Order#',
      selector: (row) => `${row.id}`,
      width: '80px',
    },
    {
      name: 'Invoice Date',
      selector: (row) => (row['invoice_date'] ? row['invoice_date'] : row['createdAt']),
      sortable: true,
      center: false,
      width: '160px',
    },
    {
      name: 'Name',
      selector: (row) => `${row.first_name} ${row.last_name}`,
      sortable: true,
      center: false,
      headerStyle: (selector, id) => {
        return { textAlign: 'left' };
      },
    },
    {
      name: 'Email',
      selector: (row) => row['email'],
      sortable: true,
      center: false,
      width: '160px',
    },
    // {
    //   name: 'Preparation Date',
    //   selector: (row) => row['preparation_date'],
    //   sortable: true,
    //   center: false,
    //   width: '160px',
    // },
    {
      name: 'Status',
      selector: (row) => row['status'],
      sortable: true,
      center: false,
    },
    {
      name: 'Subscription',
      selector: (row) => row['duration'],
      sortable: true,
      center: false,
    },
    {
      name: 'Items',
      cell: (row) => formatOrderItemsInline(row.order_items),
      sortable: false,
      center: false,
      grow: 1.2,
      wrap: true,
    },
    {
      name: 'Amount',
      selector: (row) => row['totalPrice'],
      sortable: true,
      center: false,
    },
    {
      name: 'Email Count',
      selector: (row) => row['email_count'],
      sortable: true,
      center: false,
    },
    {
      name: 'Action',
      width: '140px',
      cell: (row) => <Btn attrBtn={{ color: 'primary', onClick: () => handleAction(row) }}>{'View'}</Btn>,
    },
  ];

  console.log('allOrders', allOrders);

  // Debounce search term to avoid too many API calls
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
      setCurrentPage(1); // Reset to first page when searching
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
  };

  const handleStatus = (event) => {
    const value = event.target.value;
    setStatusFilter(value);
    setCurrentPage(1); // Reset to first page when filtering
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPageSize(newPerPage);
    setCurrentPage(page);
  };

  const cogs = useMemo(
    () =>
      ingredients?.reduce((sum, item) => {
        return sum + (parseFloat(item.cogs) || 0);
      }, 0),
    [ingredients]
  );
  const numberOfMonths = [6, 90].includes(parseInt(order?.duration)) ? 3 : 1;
  const totalOrderCogs = cogs * 30 * numberOfMonths;

  return (
    <Fragment>
      <h1>Orders</h1>
      <Container fluid={true}>
        <Card>
          <CardBody>
            <Row>
              <div className="col-8">
                <input
                  type="text"
                  placeholder="Search by order ID, name, email, or status"
                  value={searchTerm}
                  onChange={handleSearch}
                  className="form-control col-8"
                />
              </div>
              <div className="col-4">
                <select className="form-control col-4" onChange={handleStatus}>
                  <option value="">Select Status</option>
                  <option value="">All</option>
                  <option value="pending">Pending</option>
                  <option value="dispatched">Dispatched</option>
                </select>
              </div>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            {!isLoading && (
              <div className="my-3 text-muted">
                Showing {data.length} of {totalRows} orders
              </div>
            )}

            <DataTable
              columns={tableColumns}
              data={data}
              expandableRows
              expandableRowsComponent={OrderItemsExpanded}
              expandableRowDisabled={(row) => !Array.isArray(row?.order_items) || row.order_items.length === 0}
              striped={true}
              center={true}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              progressPending={isLoading}
              //selectableRows
              //selectableRowsSingle
              selectableRowsHighlight
              onSelectedRowsChange={handleRowSelected}
              clearSelectedRows={toggleSelect}
              paginationPerPage={pageSize}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
              paginationComponentOptions={{
                noRowsPerPage: false, // Hide the dropdown that allows changing the number of rows per page
              }}
            />
          </CardBody>
        </Card>

        <Row>
          <Col sm="7">
            <Card>
              <CardBody>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="text-start">
                      <h3>
                        Order # <span className="digits counter">{order.id}</span>
                      </h3>
                      <p>
                        Date: {order.date}
                        <br />
                        Amount: <span className="digits">{order.amount}</span>
                        <br />
                        Subscription: <span className="digits">{order.duration}</span>
                        <br />
                        Current Status: <span style={{ textTransform: 'capitalize' }}>{order.status}</span>
                        &nbsp;
                        {order.details}
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6 text-end">
                    <div ref={shippingAddressRef} className="m-2 mt-0">
                      <h3>Shipping Address</h3>
                      <p>
                        {shipAddress.companyName}
                        <br />
                        {shipAddress.firstName}&nbsp;{shipAddress.lastName}
                        <br />
                        {shipAddress.appartment}
                        <br />
                        {shipAddress.address}
                        <br />
                        {shipAddress.state}&nbsp;({shipAddress.zipCode})
                        <br />
                        {shipAddress.phoneNo}
                      </p>
                    </div>
                    <Btn
                      attrBtn={{
                        className: 'mt-3',
                        color: 'primary',
                        onClick: () => printShipAddress(),
                      }}
                    >
                      <i class="fa fa-print me-1" /> {'Print'}
                    </Btn>
                  </div>
                </div>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <h4> Total Material Cogs</h4>
                <p>{totalOrderCogs.toFixed(2)}</p>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <Row>
                  <div className="col-sm-6">
                    <h4>Add Status</h4>
                    <select className="form-control" onChange={(e) => setStatus(e.target.value)}>
                      <option value="">--Select Status--</option>
                      <option value="Under Process">Under Process</option>
                      <option value="Ready to dispatch">Ready to dispatch</option>
                      <option value="Dispatched">Dispatched</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                    {showError.status === '' ? '' : <span className="text-danger">Please select status</span>}
                    <input
                      type="text"
                      onChange={(e) => {
                        e.preventDefault();
                        setDetails(e.target.value);
                      }}
                      className="form-control mt-3"
                    />

                    <Btn
                      attrBtn={{
                        className: 'mt-3',
                        color: 'primary',
                        onClick: () => toggleModal(),
                      }}
                    >
                      {'Update Status'}
                    </Btn>
                  </div>
                  <div className="col-sm-6 text-end">
                    <h4>Status</h4>
                    <table className="table text-start">
                      <tbody>
                        {statuses && (
                          <tr>
                            <td>{statuses?.status}</td>
                            <td>{statuses?.details}</td>
                            <td>{statuses?.date}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </Row>
              </CardBody>
            </Card>
          </Col>

          <Col sm="5">
            <Card>
              <CardBody className="personalized-formula">
                <div className="table-responsive">
                  <div className="text-end">
                    <Btn
                      attrBtn={{
                        className: 'mr-2',
                        color: 'primary',
                        disabled: !ingredients.length,
                        onClick: () => downloadCsv(ingredients, ['ingredient', 'daily_dose', 'per_eu_nrv']),
                      }}
                    >
                      Download
                    </Btn>
                  </div>
                  <table className="table accordion" id="accordionExample">
                    <thead>
                      <tr>
                        <th scope="col" className="col-8">
                          Nutrient
                        </th>
                        <th scope="col">Quantity</th>
                        <th scope="col">% NRV</th>
                        <th scope="col">Daily Cogs</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ingredients &&
                        ingredients.map((item) => (
                          <tr>
                            <td>{item.ingredient}</td>
                            <td>{item.daily_dose} mg</td>
                            <td>{item.per_eu_nrv === 0 ? '*' : `${item.per_eu_nrv}%`}</td>
                            <td>{item?.cogs ? item.cogs : 0}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {questionsAnswers && personalInfo && (
          <Card>
            <CardBody>
              <Row style={{ gap: 12 }}>
                <h3>Quiz Question Answers</h3>
                {Object.keys(personalInfo).map((item, i) => (
                  <div key={'personal-info-' + i} className="">
                    <div
                      dangerouslySetInnerHTML={{ __html: item }}
                      style={{
                        fontWeight: 500,
                        fontSize: '15px',
                        textTransform: 'capitalize',
                      }}
                    />
                    <div
                      dangerouslySetInnerHTML={{
                        __html: personalInfo[item],
                      }}
                    />
                  </div>
                ))}
                {questionsAnswers.slice(1, questionsAnswers.length).map((item, i) => (
                  <div key={'qa-' + i} className="">
                    <div
                      dangerouslySetInnerHTML={{ __html: item.question }}
                      style={{
                        fontWeight: 500,
                        fontSize: '15px',
                      }}
                    />
                    <div dangerouslySetInnerHTML={{ __html: formatQuizAnswer(item.answer) }} />
                  </div>
                ))}
              </Row>
            </CardBody>
          </Card>
        )}

        <ConfirmationModal
          message={'Are you sure to update the status?'}
          isOpen={modalOpen}
          toggle={toggleModal}
          onConfirm={handleConfirmAction}
        />
        <ToastContainer />
      </Container>
    </Fragment>
  );
};

export default Orders;
